import { apiClient } from './apiClient';
import { roleOverrideServiceMock } from './roleOverrideService.mock';
import type {
  ProjectRoleOverride,
  EmployeeRoleOverride,
  RateResolutionRequest,
  RateResolutionResponse,
} from '@/types/roleOverride';

// Set to false to use real API backed by TimeEntry database (synced from Projects)
const USE_MOCK = false;

const realRoleOverrideService = {
  // Project Role Override read operations
  async getProjectRoleOverrides(projectId?: number): Promise<ProjectRoleOverride[]> {
    const url = projectId
      ? `/role-overrides/project?projectId=${projectId}`
      : `/role-overrides/project`;
    return await apiClient.get<ProjectRoleOverride[]>(url);
  },

  async getProjectRoleOverrideById(id: number): Promise<ProjectRoleOverride> {
    return await apiClient.get<ProjectRoleOverride>(`/role-overrides/project/${id}`);
  },

  // Employee Role Override read operations
  async getEmployeeRoleOverrides(employeeId?: number, projectId?: number): Promise<EmployeeRoleOverride[]> {
    const params = new URLSearchParams();
    if (employeeId) params.append('employeeId', employeeId.toString());
    if (projectId !== undefined) params.append('projectId', projectId.toString());

    const url = `/role-overrides/employee${params.toString() ? `?${params.toString()}` : ''}`;
    return await apiClient.get<EmployeeRoleOverride[]>(url);
  },

  async getEmployeeRoleOverrideById(id: number): Promise<EmployeeRoleOverride> {
    return await apiClient.get<EmployeeRoleOverride>(`/role-overrides/employee/${id}`);
  },

  // Rate Resolution
  async resolveRate(request: RateResolutionRequest): Promise<RateResolutionResponse> {
    return await apiClient.post<RateResolutionResponse>(`/role-overrides/resolve-rate`, request);
  },
};

export const roleOverrideService = USE_MOCK ? roleOverrideServiceMock : realRoleOverrideService;
